/**
 * useNotify — Toast 通知 composable
 * 封装 Naive UI createDiscreteApi message，提供统一的 Toast 接口
 *
 * 使用方式（任意上下文，包括 Store、非组件）：
 *   const notify = useNotify()
 *   notify.success('操作成功')
 *   notify.error('操作失败')
 *
 * 技术说明：
 *   使用 createDiscreteApi 创建脱离 Vue 注入上下文的独立实例，
 *   不再依赖 NMessageProvider，可安全在 Pinia Store / 工具函数中调用。
 */
import { createDiscreteApi } from 'naive-ui'
import type { MessageOptions } from 'naive-ui'
import { themeOverrides } from '@/styles/naive-theme'

const DEFAULT_DURATION = 3000

// 全局单例：应用内共用同一个 message 实例
const { message } = createDiscreteApi(['message'], {
  configProviderProps: { themeOverrides },
})

export function useNotify() {
  function success(content: string, options?: MessageOptions) {
    message.success(content, { duration: DEFAULT_DURATION, ...options })
  }

  function warning(content: string, options?: MessageOptions) {
    message.warning(content, { duration: DEFAULT_DURATION, ...options })
  }

  function error(content: string, options?: MessageOptions) {
    message.error(content, { duration: DEFAULT_DURATION + 2000, ...options })
  }

  function info(content: string, options?: MessageOptions) {
    message.info(content, { duration: DEFAULT_DURATION, ...options })
  }

  return { success, warning, error, info }
}
